export function user(state) {
    return state.logged_user;
}
